import React, { useEffect, useState } from "react"
import {
  Button,
  Modal,
  Image,
  Accordion,
  AccordionTitle,
  AccordionContent,
  Icon
} from "semantic-ui-react"
import { connect } from "react-redux"
import { isEmpty } from "lodash"
import { withTranslation } from "react-i18next"
import { withRouter } from "react-router-dom"
import ServiceCard from "../SelectService/ServiceCard"
import { updateCart } from "../../../../v1/actions/user"
import {
  fetchOEMRangeIntevals,
  getCommonServices
} from "../../../../v1/actions/maintenanceSchedules"
import { ShimmerServiceCard } from "../../Services/ShimmerServiceCard"
import {
  fetchCarAdviseRecemendedServices,
  fetchServicesPricing
} from "../../../../v1/CarAdvise2/actions/maintenance"
import { toggleService } from "../SelectService/SelectService"
import UpsellIcon from "../../../../images/upsell_icon.svg"
import CommonUpsellIcon from "../../../../images/common_upsell_icon.svg"
import { numberFormatToCurrency } from "../../../../shared_component/utils/currency"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faClose } from "@fortawesome/pro-solid-svg-icons"
import {
  gaJSON,
  trackFirebaseAnalytics
} from "../../../../shared_component/utils/googleAnalyticsHelpers"
import { appointmentTypes, serviceRequestTypes } from "../../../constants"
import SplitClient from "../../../../v1/components/Config/SplitClient"

const UpsellServices = ({
  t,
  cart,
  order,
  vehicle,
  fetchOEMRangeIntevals,
  updateCart,
  getCommonServices,
  fetchCarAdviseRecemendedServices,
  fetchServicesPricing,
  user
}) => {
  const services = cart.order_services || []
  const [selectedPositions, setSelectedPositions] = useState({})
  const [serviceErrors, setServiceErrors] = useState({})
  const [selectedServices, setSelectedServices] = useState([])
  const [servicesUpdating, setServicesUpdating] = useState([])
  const [recommendedServices, setRecommendedServices] = useState([])
  const [commonServices, setCommonServices] = useState([])
  const [inspectionService, setInspectionService] = useState(null)
  const [currentInterval, setCurrentInterval] = useState(null)
  const [currentIntervalData, setCurrentIntervalData] = useState(null)
  const [recommendedServicesLoading, setRecommendedServicesLoading] = useState(false)
  const [modalOpen, setModalOpen] = useState(false)
  const [upsellInspectionFlag, setUpsellInspectionFlag] = useState(false)
  const [isNearInterval, setIsNearInterval] = useState(false)
  const [activeIndex, setActiveIndex] = useState(-1)

  const handleClick = (e, titleProps) => {
    const { index } = titleProps
    const newIndex = activeIndex === index ? -1 : index

    setActiveIndex(newIndex)
  }

  useEffect(() => {
    setSelectedServices(cart.order_services.map((service) => service.id))
  }, [cart.order_services])

  const getMaintenanceScheduledServices = async () => {
    setRecommendedServicesLoading(true)

    const current_interval =
      (vehicle && (await fetchOEMRangeIntevals({ vehicle: vehicle }))) || null

    const recommendedInterval =
      current_interval && current_interval.length > 0
        ? current_interval[0].interval
        : vehicle.current_interval

    const isPastDue = recommendedInterval ? vehicle.miles > recommendedInterval : false

    const isNearInterval = recommendedInterval
      ? vehicle.miles > recommendedInterval - 5000 && vehicle.miles <= recommendedInterval
      : false
    let hasInspectionService = null
    let maintenanceSchedulesServices = []

    if (isPastDue || isNearInterval) {
      let interval = null
      let services = []

      if (vehicle) {
        interval = vehicle.miles
      }

      const oemServices =
        (current_interval && current_interval.length > 0 && current_interval[0].services) || []
      const intervalId =
        current_interval && current_interval.length > 0 && current_interval[0].interval_id
      const data = {
        vehicleId: vehicle && vehicle.id,
        interval: interval,
        interval_id: intervalId,
        filter_selected: true,
        shop_id: cart.shop && cart.shop.id
      }

      if (interval !== null) {
        const carAdviseRecommendedResponse = await fetchCarAdviseRecemendedServices(data)

        if (
          carAdviseRecommendedResponse &&
          carAdviseRecommendedResponse.result &&
          !carAdviseRecommendedResponse.result.errors
        ) {
          services =
            (carAdviseRecommendedResponse.result.length > 0 &&
              carAdviseRecommendedResponse.result.map((element) => {
                let isCompleted = false
                try {
                  isCompleted = element.is_completed
                } catch (e) {}
                return element
              })) ||
            []
        }
      }

      const addedServices = cart.order_services.reduce((acc, service) => {
        acc.push(service.id)
        return acc
      }, [])

      maintenanceSchedulesServices = [...oemServices, ...services].filter(
        (s) => !addedServices.includes(s.service_id || s.id)
      )

      hasInspectionService = maintenanceSchedulesServices.find(
        (service) => service.service_id === 467
      )
    }

    setInspectionService(hasInspectionService)
    if (hasInspectionService === undefined || hasInspectionService === null) {
      setTimeout(() => {
        getCommonMaintenanceServices()
      }, 1000)
    }
    setRecommendedServices(maintenanceSchedulesServices)
    setCurrentInterval(current_interval?.[0]?.interval || vehicle.current_interval)
    setCurrentIntervalData(current_interval?.[0])
    setIsNearInterval(isNearInterval)
    setRecommendedServicesLoading(false)
  }

  const getCommonMaintenanceServices = async () => {
    let commonServicesResponse = await getCommonServices({ shop_id: cart.shop && cart.shop.id })
    if (cart.cart_type === serviceRequestTypes.WALK_IN) {
      commonServicesResponse = commonServicesResponse.filter(
        (service) => service.walkin_compatible === appointmentTypes.WALK_IN_ONLY
      )
    }

    const service_ids = commonServicesResponse.map((service) => service.id)
    const vehicleId = vehicle?.id

    if (vehicleId && !isEmpty(service_ids)) {
      const pricingResponse = await fetchServicesPricing({ vehicleId, service_ids })
      if (pricingResponse?.result) {
        const pricingMap = new Map()
        pricingResponse.result.forEach((pricedService) =>
          pricingMap.set(pricedService.id, pricedService)
        )
        commonServicesResponse.forEach((service) => {
          if (pricingMap.has(service.id)) {
            Object.assign(service, pricingMap.get(service.id))
          }
        })
      }
    }

    setCommonServices(commonServicesResponse)
  }

  useEffect(() => {
    const cartServices = cart.order_services || []
    const hasInspectionService = cartServices.some((service) => service.id === 467)
    if (recommendedServices.length > 0 && !hasInspectionService) {
      setModalOpen(true)
    } else if (commonServices.length > 0 && !hasInspectionService) {
      setModalOpen(true)
    }
  }, [recommendedServices, commonServices])

  useEffect(() => {
    if (modalOpen) {
      trackFirebaseAnalytics({
        event: gaJSON.upsell_modal_viewed,
        params: {
          item_list_id:
            recommendedServices.length > 0
              ? upsellInspectionFlag
                ? "inspection_upsell_modal"
                : "recommended_upsell_modal"
              : "standard_upsell_modal",
          flow_type:
            recommendedServices.length > 0
              ? isNearInterval
                ? "near_milestone"
                : "at_past_milestone"
              : "standard",
          mileage_interval: currentInterval || null,
          vehicle_mileage: vehicle.miles || null
        }
      })
    }
  }, [modalOpen])

  useEffect(() => {
    const getUpsellInspectionFlag = async () => {
      const treatment = await SplitClient.getTreatment("UPSELL_INSPECTION", user)
      setUpsellInspectionFlag(treatment["UPSELL_INSPECTION"] === "on")
    }
    getUpsellInspectionFlag()
    if (cart.cart_type === serviceRequestTypes.WALK_IN || user.country == "ca") {
      getCommonMaintenanceServices()
    } else {
      getMaintenanceScheduledServices()
    }
  }, [])

  const updateService = async (service, position = null) => {
    const isAdded =
      cart?.order_services?.some(
        (item) => item.service_definition_id === service.service_id || item.id === service.id
      ) ?? false
    trackFirebaseAnalytics({
      event: gaJSON.select_item,
      params: {
        item_list_id:
          recommendedServices.length > 0
            ? upsellInspectionFlag
              ? "inspection_upsell_modal"
              : "recommended_upsell_modal"
            : "standard_upsell_modal",
        flow_type:
          recommendedServices.length > 0
            ? isNearInterval
              ? "near_milestone"
              : "at_past_milestone"
            : "standard",
        item_list_name: service.name,
        event_type: isAdded ? "remove_service" : "add_service"
      }
    })
    await toggleService({
      service,
      positionOverride: position,
      cart,
      order,
      vehicle,
      selectedPositions,
      setSelectedPositions,
      setServiceErrors,
      setServicesUpdating,
      setSelectedServices,
      t,
      updateCart
    })
  }

  const handleCommonService = async (service, position = null) => {
    const isWiperBlade = service.reference_id === "windshield_wiper_blade_replacement"
    const isSelected = cart?.order_services?.some(
      (item) => item.service_definition_id === service.service_id || item.id === service.id
    )
    const effectivePositions =
      isWiperBlade && !isSelected && !position
        ? { ...selectedPositions, [service.id]: "front" }
        : selectedPositions

    await toggleService({
      service,
      positionOverride: position,
      cart,
      order,
      vehicle,
      selectedPositions: effectivePositions,
      setSelectedPositions,
      setServiceErrors,
      setServicesUpdating,
      setSelectedServices,
      t,
      updateCart
    })
  }

  const getPositions = (positions) => {
    return positions.map((position, index) => ({
      key: index,
      text: position,
      value: position
    }))
  }

  const handleClose = () => setModalOpen(false)

  const isCommonServiceSelected =
    commonServices.length > 0 &&
    commonServices.some((service) => selectedServices.includes(service.id))

  return (
    <Modal open={modalOpen} onClose={handleClose} size="tiny" className="upsell-services-modal">
      <div className="close-icon">
        <FontAwesomeIcon icon={faClose} onClick={() => handleClose()} />
      </div>
      <Modal.Content>
        <div className="upsell-services-info">
          {recommendedServicesLoading && <ShimmerServiceCard count={3} />}

          {commonServices.length > 0 && (
            <div className="commom-services-card">
              <Image src={CommonUpsellIcon} width={56} height={56} className="upsell-icon" />
              <p className="services-mark">Make the most of your visit </p>
              <p>
                Bundling these common services means one less appointment on your calendar later.
              </p>
              {commonServices.sort().map((service) => {
                service.walkin_compatible = appointmentTypes.WALK_IN_ONLY
                return (
                  <React.Fragment key={service.id}>
                    <ServiceCard
                      service={service}
                      selectedServices={selectedServices}
                      selectedPositions={selectedPositions}
                      serviceErrors={serviceErrors}
                      handleService={handleCommonService}
                      updateServiceWithPosition={handleCommonService}
                      getPositions={getPositions}
                      isUpdating={servicesUpdating.includes(service.id)}
                      hidePositions={true}
                    />
                  </React.Fragment>
                )
              })}
            </div>
          )}

          {!recommendedServicesLoading && !!inspectionService && recommendedServices.length > 0 && (
            <div>
              <Image src={UpsellIcon} width={56} height={56} className="upsell-icon" />
              <p className="services-mark">
                {isNearInterval ? "Plan" : "It's time"} for your {currentInterval}-mi service
              </p>
              <p>
                Your vehicle needs specific care to stay reliable. <br />
                {upsellInspectionFlag ? (
                  isNearInterval ? (
                    "An inspection can pinpoint what is critical now to work around your budget."
                  ) : (
                    <b>
                      Book an inspection now to pinpoint what is critical to work around your
                      budget.
                    </b>
                  )
                ) : (
                  "Sticking to this schedule prevents expensive repairs down the road."
                )}
              </p>
              {upsellInspectionFlag ? (
                <div className="recommended-services-card">
                  {inspectionService && (
                    <div className="inspection-service">
                      <p>{inspectionService.name} </p>
                      <div className="service-price-info">
                        {inspectionService.high_price_estimate &&
                        inspectionService.low_price_estimate &&
                        inspectionService.high_price_estimate.shop_price_estimate !=
                          inspectionService.low_price_estimate.shop_price_estimate ? (
                          <p className="price-text">
                            {" "}
                            {`${numberFormatToCurrency(
                              inspectionService.low_price_estimate.shop_price_estimate
                            )} - ${numberFormatToCurrency(
                              inspectionService.high_price_estimate.shop_price_estimate
                            )}`}
                          </p>
                        ) : inspectionService.high_price_estimate ? (
                          `${numberFormatToCurrency(
                            inspectionService.high_price_estimate.shop_price_estimate
                          )}`
                        ) : inspectionService.price_range_from &&
                          inspectionService.price_range_to ? (
                          <p className="price-text">
                            {" "}
                            {`${numberFormatToCurrency(
                              inspectionService.price_range_from
                            )} - ${numberFormatToCurrency(inspectionService.price_range_to)}`}
                          </p>
                        ) : !user?.activeVehicleId ? (
                          <p className="price-text">{t("addTheVehicleLabel")}</p>
                        ) : (
                          <p className="price-text">{t("orderServicePriceRow:pricedAtShop")}</p>
                        )}
                      </div>
                    </div>
                  )}
                  <div className="recommended-services-list">
                    <Accordion>
                      <AccordionTitle active={activeIndex === 0} index={0} onClick={handleClick}>
                        <Icon name="dropdown" />
                        {currentInterval}-mi recommended services
                      </AccordionTitle>
                      <AccordionContent active={activeIndex === 0}>
                        {recommendedServices.sort().map((service) => {
                          return (
                            <React.Fragment key={service.id}>
                              <ServiceCard
                                service={service}
                                selectedServices={selectedServices}
                                isUpdating={servicesUpdating.includes(service.id)}
                                recommendedServices={false}
                                hideActionButtons={true}
                              />
                            </React.Fragment>
                          )
                        })}
                      </AccordionContent>
                    </Accordion>
                  </div>
                </div>
              ) : (
                <div className="commom-services-card">
                  {recommendedServices.sort().map((service) => {
                    service.walkin_compatible = appointmentTypes.WALK_IN_ONLY
                    return (
                      <React.Fragment key={service.id}>
                        <ServiceCard
                          service={service}
                          selectedServices={selectedServices}
                          selectedPositions={selectedPositions}
                          serviceErrors={serviceErrors}
                          handleService={updateService}
                          updateServiceWithPosition={updateService}
                          getPositions={getPositions}
                          isUpdating={servicesUpdating.includes(service.id)}
                        />
                      </React.Fragment>
                    )
                  })}
                </div>
              )}
            </div>
          )}
        </div>
      </Modal.Content>
      <Modal.Actions>
        <div className="upsell-services-actions">
          <Button
            fluid
            onClick={async () => {
              if (inspectionService && upsellInspectionFlag) {
                await updateService(inspectionService, null)
              }
              handleClose()
            }}
            loading={servicesUpdating.includes(inspectionService?.id)}
            disabled={
              servicesUpdating.includes(inspectionService?.id) ||
              (commonServices.length > 0 && !isCommonServiceSelected)
            }
            className="primary-button"
          >
            {upsellInspectionFlag && commonServices.length == 0
              ? t("Add inspection")
              : t("Continue")}
          </Button>
          <Button
            fluid
            onClick={handleClose}
            className="secondary-button"
            loading={servicesUpdating.includes(inspectionService?.id)}
            disabled={servicesUpdating.includes(inspectionService?.id)}
          >
            {t("No, thanks")}
          </Button>
        </div>
      </Modal.Actions>
    </Modal>
  )
}

function mapStateToProps(state, props) {
  let user = state.user || {}
  let activeVehicle = (user.vehicles || []).find((v) => v.id === user.activeVehicleId) || {}
  let cart
  let currentActiveOrder =
    user.active_orders && user.active_orders.find((o) => o.vehicle_id == user.activeVehicleId)

  if (currentActiveOrder) {
    cart = currentActiveOrder
  } else {
    if (props.cartId) {
      cart = user.active_carts && user.active_carts.filter((c) => c.id == Number(props.cartId))[0]
    } else {
      cart =
        user.active_carts && user.active_carts.find((c) => c.vehicle_id == user.activeVehicleId)
    }
  }

  if (!cart || !cart.order_services) {
    cart = { estimated_total: 0, order_services: [] }
  }

  return {
    user: user,
    cart: cart,
    order: currentActiveOrder,
    vehicle: activeVehicle
  }
}

export default withRouter(
  connect(mapStateToProps, {
    updateCart,
    fetchOEMRangeIntevals,
    getCommonServices,
    fetchCarAdviseRecemendedServices,
    fetchServicesPricing
  })(withTranslation("addService")(UpsellServices))
)
